/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import area from './utils/area'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
// import axios from "./axios.js"
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.prototype.$http = axios
Vue.prototype.area = area
Vue.use(VueAxios, axios)

// let baseURL = '/api';
// // process.env.NODE_ENV  用于判断当前运行环境，根据 npm run serve 或 npm run build
// if (process.env.NODE_ENV === 'production') {
//   baseURL =  'http://adminapi.eurcd.dev.instatech.cn/api/';
// }

axios.defaults.baseURL = env.API_HOST

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

Vue.config.productionTip = false

// Vue Router
import router from './router'
Vue.router = router
Vue.use(ElementUI)

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  //   authRedirect: { path: '/register' }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
